import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import UnlinkCategoriesServices from "./unlink_categories.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getUnlinkCategories = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_UNLINK_CATEGORIES,
      payload: true,
    });
    const resp = await UnlinkCategoriesServices.getUnlinkCategories(filters);
    dispatch({
      type: actions.GET_UNLINK_CATEGORIES,
      payload: {
        unlinkCategories: resp.data.data,
        unlinkCategoriesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.UNLINK_CATEGORIES_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.UNLINK_CATEGORIES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_UNLINK_CATEGORIES,
      payload: false,
    });
  }
};

export const saveUnlinkCategories = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_UNLINK_CATEGORIES,
      payload: true,
    });
    const resp = await UnlinkCategoriesServices.saveUnlinkCategories(data);
    const { unlinkCategories, unlinkCategoriesLength } = getState().unlinkCategories;
    const aUnlinkCategories = [...unlinkCategories, resp.data];
    dispatch({
      type: actions.GET_UNLINK_CATEGORIES,
      payload: {
        unlinkCategories: aUnlinkCategories,
        unlinkCategoriesLength: unlinkCategoriesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_UNLINK_CATEGORIES,
      payload: false,
    });
  }
};

export const editUnlinkCategories = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_UNLINK_CATEGORIES,
      payload: true,
    });
    const resp = await UnlinkCategoriesServices.editUnlinkCategories(id, data);
    const { unlinkCategories, unlinkCategoriesLength } = getState().unlinkCategories;
    unlinkCategories[index] = resp.data;
    dispatch({
      type: actions.GET_UNLINK_CATEGORIES,
      payload: {
        unlinkCategories: unlinkCategories,
        unlinkCategoriesLength: unlinkCategoriesLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_UNLINK_CATEGORIES,
      payload: false,
    });
  }
};

export const deleteUnlinkCategories = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_UNLINK_CATEGORIES,
      payload: true,
    });
    await UnlinkCategoriesServices.deleteUnlinkCategories(id);
    const { unlinkCategories, unlinkCategoriesLength } = getState().unlinkCategories;
    unlinkCategories.splice(index, 1);
    dispatch({
      type: actions.GET_UNLINK_CATEGORIES,
      payload: {
        unlinkCategories: unlinkCategories,
        unlinkCategoriesLength: unlinkCategoriesLength - 1,
      },
    });
    dispatch({
      type: actions.UNLINK_CATEGORIES_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.UNLINK_CATEGORIES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_UNLINK_CATEGORIES,
      payload: false,
    });
  }
};
